module.exports = __webpack_public_path__ + "img/icon06.aa0e3c0e.png";